import { Pipe, PipeTransform } from '@angular/core';

// Peter Matuchniak:  use this as a generic way of filtering out items
//                    by declaring a function within the UI component module 
// ref: https://stackoverflow.com/questions/34164413/how-to-apply-filters-to-ngfor

@Pipe({
  name: 'filtercallback'
  , pure: false
})
export class FiltercallbackPipe implements PipeTransform 
{
  transform(items: any[], Filtercallback: (item: any) => boolean): any 
  {
    if (!items || !Filtercallback) 
    {
        return items;
    }
    console.log("FiltercallbackPipe.transform ", Filtercallback);
    return items.filter(item => Filtercallback(item));
  }

}

/*
@Pipe({
  name: 'callback',
  pure: false
})
export class CallbackPipe implements PipeTransform {
  transform(items: any[], callback: (item: any) => boolean): any {
      if (!items || !callback) {
          return items;
      }
      return items.filter(item => callback(item));
  }
}
*/

